module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ovf-hd p-t-10 p-b-50"
  }, [_c('div', {
    staticClass: "ovf-hd"
  }, [_vm._t("myFlow"), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")], true), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.flows
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "编号",
      "prop": "num",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "主题",
      "header-align": "center"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.caseId === 1) ? _c('div', {
          staticClass: "tx-c text-overflow"
        }, [_c('router-link', {
          staticClass: "c-icon-blue pointer",
          attrs: {
            "to": {
              name: 'myFlowDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type_id: scope.row.type_id,
                type: _vm.caseId,
                node_id: scope.row.case_node_id
              }
            },
            "title": scope.row.name
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.name) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.caseId === 2) ? _c('div', {
          staticClass: "tx-c text-overflow"
        }, [_c('router-link', {
          staticClass: "c-icon-blue pointer",
          attrs: {
            "to": {
              name: 'followDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type_id: scope.row.type_id,
                type: _vm.caseId,
                node_id: scope.row.case_node_id
              }
            },
            "title": scope.row.name
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.name) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.caseId === 3) ? _c('div', {
          staticClass: "tx-c text-overflow"
        }, [_c('router-link', {
          staticClass: "c-icon-blue pointer",
          attrs: {
            "to": {
              name: 'dataDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type_id: scope.row.type_id,
                type: _vm.caseId,
                node_id: scope.row.case_node_id
              }
            },
            "title": scope.row.name
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.name) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.caseId === 4) ? _c('div', {
          staticClass: "tx-c text-overflow"
        }, [_c('router-link', {
          staticClass: "c-icon-blue pointer",
          attrs: {
            "to": {
              name: 'myStartDetail',
              params: {
                id: scope.row.id
              },
              query: {
                type_id: scope.row.type_id,
                type: _vm.caseId,
                node_id: scope.row.case_node_id
              }
            },
            "title": scope.row.name
          }
        }, [_vm._v("\n                " + _vm._s(scope.row.name) + "\n              ")])]) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请人",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_vm._v("\n              " + _vm._s(scope.row.apply_name) + "\n            ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "流程发起时间",
      "header-align": "center",
      "sortable": "",
      "width": "150"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticClass: "tx-c"
        }, [_vm._v("\n              " + _vm._s(_vm._f("toTime")(scope.row.create_time)) + "\n            ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deal_time",
      "label": "最后处理时间",
      "header-align": "center",
      "sortable": "",
      "width": "150"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticClass: "tx-c"
        }, [_vm._v("\n              " + _vm._s(_vm._f("toTime")(scope.row.deal_time)) + "\n            ")])]
      }
    }
  }), _vm._v(" "), (!(_vm.caseId === 1)) ? _c('el-table-column', {
    attrs: {
      "prop": "case_status",
      "label": "状态"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.caseId == 3) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [(_vm.caseId == 3) ? _c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": "bpm/flowCases/deletes",
      "need": "del"
    },
    on: {
      "setLoading": _vm.setLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-sizes": [10, 15, 20],
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dd01b32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/common/flowList.vue
// module id = 1808
// module chunks = 2